import { toJson } from '@bufbuild/protobuf';
import type { DescMessage, MessageShape } from '@bufbuild/protobuf';

/**
 * protobuf 응답 메시지를 서버가 내보내던 JSON 표현 그대로 되돌린다.
 *
 * ⚠️ Connect 클라이언트 응답을 그대로 화면에 넘기면 안 된다. protobuf-es 의 메시지
 * 객체는 enum 필드를 **숫자**로 들고 있다(`tag: 1`, `category: 3`). 종전 손수 만든
 * JSON fetch 는 connect-go 의 protojson 응답을 그대로 받아 `tag: "EC"` 였고, 뷰어·표·
 * JSON 탭·교정 UI 가 전부 그 이름 표기를 전제로 짜여 있다. 이걸 빼먹어서 형태소 뷰어
 * 툴팁이 "으니까/1" 로 나왔다(#1851).
 *
 * - enumAsInteger 기본값(false) → enum 은 이름으로 나간다. 이게 핵심이다.
 * - alwaysEmitImplicit → 서버 JSON 코덱의 EmitUnpopulated:true 와 맞춘다(0·false·빈
 *   문자열 필드도 남아 있어야 기존 화면 계약이 유지된다).
 * - 덤으로 $typeName 노이즈가 사라져 JSON 탭이 실제 API 응답과 같아진다.
 *
 * 반환 타입이 느슨한 것은 코드 생성에 json_types 옵션을 켜지 않아서다. 켜면 JSON 타입이
 * 생성물에 따라오지만 protobuf 생성물 전체가 바뀌므로 지금은 캐스팅으로 둔다.
 */
export const JSON_WRITE_OPTIONS = { alwaysEmitImplicit: true } as const;

export function toProtoJson<Desc extends DescMessage>(
  schema: Desc,
  message: MessageShape<Desc>
): Record<string, any> {
  return toJson(schema, message, JSON_WRITE_OPTIONS) as Record<string, any>;
}

/** 위 변환에 `{ ok: true }` 를 붙인 형태. 서버 액션들이 쓰는 반환 규약이다. */
export function toProtoJsonResult<Desc extends DescMessage>(
  schema: Desc,
  message: MessageShape<Desc>
): { ok: true; [field: string]: any } {
  return { ok: true as const, ...toProtoJson(schema, message) };
}
